import { tns } from 'tiny-slider/src/tiny-slider'

// POSSIBLE OPTIONS
// Also find more documentation here: http://ganlanyuan.github.io/tiny-slider/demo/
var default_options = {
//     container: '.slider',
//     mode: 'carousel',
//     axis: 'horizontal',
	items: 1,
//     gutter: 0,
//     edgePadding: 0,
//     fixedWidth: false,
//     autoWidth: false,
//     viewportMax: false,
// 	   slideBy: 2,
//     center: false,
	controls: false,
//     controlsPosition: 'top',
//     controlsText: ['prev', 'next'],
//     controlsContainer: false,
//     prevButton: false,
//     nextButton: false,
	nav: true,
	navPosition: 'bottom',
//     navContainer: false,
//     navAsThumbnails: false,
//     arrowKeys: false,
//     speed: 300,
    autoplay: false,
//     autoplayPosition: 'top',
    autoplayTimeout: 5000,
//     autoplayDirection: 'forward',
//     autoplayText: ['start', 'stop'],
//     autoplayHoverPause: false,
	autoplayButton: false,
	autoplayButtonOutput: false,
//     autoplayResetOnVisibility: true,
//     animateIn: 'tns-fadeIn',
//     animateOut: 'tns-fadeOut',
//     animateNormal: 'tns-normal',
//     animateDelay: false,
    loop: true,
//     rewind: false,
	autoHeight: true,
//     responsive: false,
//     lazyload: false,
//     lazyloadSelector: '.tns-lazy-img',
//     touch: true,
    mouseDrag: true,
    lazyload: true,
//     swipeAngle: 15,
//     nested: false,
//     preventActionWhenRunning: false,
//     preventScrollOnTouch: false,
//     freezable: true,
//     onInit: false,
//     useLocalStorage: true
}

// Hero slider
export default function initSliders () {
	var sliders = getSliders(['[data-slider]']);
	var result = {};

	if (!sliders) return

	for ( var sliderssss of sliders ) {
		name = getSliderName(sliderssss)
		result[name] = initSlider(sliderssss )
	}

	return result;
}

function getSliders (selector) {
	return document.querySelectorAll(selector)
}

function getSliderElements (name) {
	let elements = {
		prevButton: document.querySelector('[data-slider-prev="' + name + '"]'),
		nextButton: document.querySelector('[data-slider-next="' + name + '"]'),
		counter: document.querySelector('[data-slider-counter="' + name + '"]')
	}

	console.log(elements);
	if (elements.prevButton != null || elements.nextButton != null ) {
		elements.controls = true;
	}

	console.log(elements);

	return elements
}

function getSliderOptions (slider) {
	return JSON.parse(slider.getAttribute('data-slider-options'))
}

function getSliderName (slider) {
	return slider.getAttribute('data-slider')
}

function configSlider (slider) {
	var name = getSliderName(slider)

	let config = default_options
	let elements = getSliderElements(name)

	if (elements) {
		config = Object.assign(config, elements)
	}

	var options = getSliderOptions(slider)

	if (options) {
		config = Object.assign(config, options)
	}

	config = Object.assign(config, {'container': slider})
	return config;
}

// Hero slider
function initSlider (element) {

	var config = configSlider(element);
	var slider = tns(config);
	var sliderCounter = config.counter;

	slider.events.on('indexChanged', function (info, eventName) {
	console.log(info);

		if (sliderCounter) {
			let newValue = info.displayIndex + ' / ' + info.slideCount;
			updateCounter(sliderCounter, newValue)
		}
	})

	return slider
}

function updateCounter (counter, newValue) {
	counter.innerText = newValue
}
